<template>
  <gj-popover
    v-model="visible"
    placement="top"
    title="竞价策略"
    width="800"
    lazy
    trigger="manual"
    @show="popoverShow">
    <div class="gj-cell-display-switch" slot="reference" @click="showEdit()" v-if="isEdit">
      <i class="el-icon-edit"></i>
    </div>
    <AppBidStrategyPicker :form="form"></AppBidStrategyPicker>
    <div style="text-align: right; margin-top: 14px">
      <gj-button :size="'mini'" @click="close()">取消</gj-button>
      <gj-button :size="'mini'" type="primary" @click="confirm()" :loading="loading" >确定</gj-button>
    </div>
  </gj-popover>
</template>

<script>
import AppBidStrategyPicker from "modules/ad/sp/common/modal/add/common/bid-strategy-picker";
export default {
  name: "ad-edit-bidStrategy",
  components: { AppBidStrategyPicker },
  props: {
    value: {},
    isEdit: {
      type: Boolean,
      default: true
    },
    updateValue: {
        type: Function
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        bidStrategyType: null,
        homePercentage: null,
        productPercentage: null
      },
    };
  },
  methods: {
    popoverShow() {
      this.form.bidStrategyType = this.value.biddingVO.strategy;
      let homePercentage = this.value.biddingVO?.placementBidding?.find(e => e?.placement === 'PLACEMENT_TOP')
      let productPercentage = this.value.biddingVO?.placementBidding?.find(e => e?.placement === 'PLACEMENT_PRODUCT_PAGE')
      this.form.homePercentage = homePercentage ? homePercentage.percentage : null;
      this.form.productPercentage = productPercentage ? productPercentage.percentage : null;
    },
    close() {
      this.visible = false;
    },
    async confirm() {
      this.loading = true;
      try {
        await this.updateValue(this.form, this.value);
        this.visible = false;
      } finally {
        this.loading = false;
      }
      
    },
    showEdit() {
      this.visible = true;
    },
  },
};
</script>

<style scoped lang='scss'>
.el-icon-edit {
  font-size: 13px;
}
/deep/ .el-popover {
  padding: 16PX !important;
}
</style>